import { render, staticRenderFns } from "./StartAt.vue?vue&type=template&id=3f63f582"
import script from "./StartAt.vue?vue&type=script&lang=js"
export * from "./StartAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports